import * as React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { LoadingOverlay } from 'components/Loader/LoadingOverlay';

const FirstChild = (props) => React.Children.toArray(props.children)[0] || null;

interface IProps {
	active?: boolean;
	text?: string;
	spinner?: boolean;
	spinnerSize?: string;
	className?: string;
	background?: string;
	color?: string;
	zIndex?: number;
	animate?: boolean;
	onClick?: any;
	style?: React.CSSProperties;
	pointerEventsNone?: boolean;
}

class LoadingOverlayWrapper extends React.Component<IProps, {}> {
	private wrapper: any;
	public static defaultProps: IProps;

	public componentDidUpdate() {
		const s = this.props.style;
		if (this.props.active && (s.overflow || s.overflowY || s.overflowX)) {
			this.wrapper.scrollTop = 0;
		}
	}

	public render() {
		const { active, animate, spinner } = this.props;

		let loadNode = active && <LoadingOverlay key="the_dimmer" {...this.props} />;
		if (animate || spinner) {
			loadNode = (
				<CSSTransitionGroup
					transitionName="_loading-overlay-transition"
					transitionAppear={true}
					transitionEnterTimeout={500}
					transitionLeaveTimeout={100}
					transitionAppearTimeout={500}
					component={FirstChild}
				>
					{loadNode}
				</CSSTransitionGroup>
			);
		}

		const styles = {
			position: 'relative' as const,
			...this.props.style,
		};

		if (active) {
			if (styles.overflow) {
				styles.overflow = 'hidden';
			}
			if (styles.overflowY) {
				styles.overflowY = 'hidden';
			}
			if (styles.overflowX) {
				styles.overflowX = 'hidden';
			}
		}
		return (
			<div
				ref={(n) => {
					this.wrapper = n;
				}}
				className={this.props.className}
				style={styles}
			>
				{loadNode}
				{this.props.children}
			</div>
		);
	}
}

LoadingOverlayWrapper.defaultProps = {
	active: false,
	className: '_loading-overlay',
	background: 'rgba(0, 0, 0, 0.05)',
	spinner: true,
	spinnerSize: '50px',
	color: '#FFF',
	zIndex: 800,
	animate: false,
	style: {},
};

export { LoadingOverlayWrapper };
